import { useEffect, useState } from 'react'

const useIssueExchangeOrderProcessing = (selectedStore, allowsExchangeOrderProcessing, isInstant) => {
  const [issueExchangeOrderProcessing, setIssueExchangeOrderProcessing] = useState(false)

  useEffect(() => {
    if (allowsExchangeOrderProcessing) {
      if (isInstant) {
        setIssueExchangeOrderProcessing(selectedStore?.preferences?.instant_exchange_orders_automatic_creation)
      } else {
        setIssueExchangeOrderProcessing(selectedStore?.preferences?.exchange_orders_automatic_creation)
      }
    } else {
      setIssueExchangeOrderProcessing(false)
    }
  }, [
    allowsExchangeOrderProcessing,
    isInstant,
    selectedStore?.preferences?.exchange_orders_automatic_creation,
    selectedStore?.preferences?.instant_exchange_orders_automatic_creation,
  ])

  return { issueExchangeOrderProcessing, setIssueExchangeOrderProcessing }
}

export default useIssueExchangeOrderProcessing
